import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logo.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-165ed7c4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "scan-login"
};
var _hoisted_2 = {
  class: "centont"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "logo"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "公司logo"
  })], -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "扫码登录", -1);
});

var _hoisted_5 = {
  class: "qr-code-container"
};
var _hoisted_6 = {
  key: 0,
  class: "qr-code-wrapper"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  key: 0,
  class: "overlay"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "二维码已失效", -1);
});

var _hoisted_10 = {
  key: 1
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "正在加载二维码...", -1);
});

var _hoisted_12 = [_hoisted_11];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [$data.qrCodeUrl ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
    src: $data.qrCodeUrl,
    alt: "二维码"
  }, null, 8, _hoisted_7), $data.isQrCodeExpired ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.refreshQrCode && $options.refreshQrCode.apply($options, arguments);
    })
  }, "点击刷新")])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))])])]);
}